<template>
  <div
    :class="
      activePoint.id === point.id
        ? 'spsmodal-overlay active '
        : 'spsmodal-overlay'
    "
    @click="$emit('closespmodal')"
  >

    <div class="overmodal">
      <div class="spsmodal" @click.stop>
        <div class="infomodal">
          <div class="imgprov">
            <img v-if="providerImage" :src="providerImage" alt="" />
          </div>
          <div v-if="point.code" class="providerCodePoint">
            <span>
              {{ point.code }}
            </span>
          </div>
        </div>
        <h6 v-html="title"></h6>
        <div class="spcontent" v-html="content"></div>
        <br />
        <button
          v-if="activePoint.id != point.id"
          class="spbutton"
          @click="$emit('pickpointmodal', $event, point)"
        >
          Wybierz punkt
        </button>
        <button
          v-if="activePoint.id == point.id"
          class="spbutton"
          @click="$emit('closespmodal', $event, point)"
        >
          Zamknij
        </button>
      </div>
    </div>
    <div class="spsclose"></div>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  data() {
    return {
      providerImage: "",
      providersList: this.Providers,
    };
  },
  methods: {
    // providerImage(){
    //   return 'https://bi.im-g.pl/im/8a/4d/1b/z28629130IC.jpg';
    // }
  },
  mounted() {
    Object.values(this.providersList).forEach((value) => {
      if (this.point.provider == value.name) {
        this.providerImage = value.image;
      }
    });
  },
  props: {
    msg: String,
    title: String,
    content: String,
    point: Object,
    activePoint:[],
    Providers: Array,
  },
};
</script>

<style scoped>
.infomodal {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.imgprov {
  margin-right: 10px;
}
.imgprov img {
  width: 38px;
  height: 38px;
  border-radius: 3px;
}
button:focus {
  outline: 0;
}
.spsmodal-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #0000008f;
  z-index: 9999;
}
.spsmodal-overlay .overmodal {
  align-self: center;
  border-radius: 5px;
  background: gray;
}

.spsmodal-overlay.active .overmodal {
  align-self: center;
  border-radius: 5px;
  background: linear-gradient(45deg, #ff0077, #f29d01) !important;
}

.spsmodal {
  background: #ffff;
  border-radius: 5px;
  margin: 6px;
  align-self: center;
  padding: 20px;
}

.spsclose {
  margin: 10% 0 0 16px;
  cursor: pointer;
}

.spsclose-img {
  width: 25px;
}

.spscheck {
  width: 150px;
}

h6 {
  font-weight: 500;
  font-size: 20px;
  margin: 10px 0;
}

p {
  font-size: 14px;
  margin: 10px 0;
}
.providerCodePoint span {
  display: block;
  border: 1px solid black;
  padding: 6px;
  border-radius: 3px;
  font-weight: 500;
}
button.spbutton {
  border-radius: 50px;
  border: 0;
  font-size: 1rem;
  color: white !important;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  height: initial !important;
  max-width: initial !important;
  min-width: initial !important;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: normal;
  background: linear-gradient(45deg, #ff0077, #f29d01) !important;
  padding: 0.6rem;
}
button.spbutton:hover {
  cursor: pointer;
}
</style>
